export default "https://cdn-static.gokick.com/assets/89c12df47656b56f32e50d5631dab02a560652ab/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";